// extracted by mini-css-extract-plugin
export default {"block":"DeleteAccountBlock_block","blockDescription":"DeleteAccountBlock_blockDescription","deleteButton":"DeleteAccountBlock_deleteButton"};